import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import BrandBanner from './components/BrandBanner';
import TabbyBanner from './components/TabbyBanner';
import CategoriesSection from './components/CategoriesSection';
import FeaturedProducts from './components/FeaturedProducts';
import FeaturesSection from './components/FeaturesSection';
import SuccessStoriesSection from './components/SuccessStoriesSection';
import CTASection from './components/CTASection';
import AboutSection from './components/AboutSection';
import TestimonialsSection from './components/TestimonialsSection';

export default function HomePage() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <BrandBanner />
      <TabbyBanner />
      <FeaturesSection />
      <CategoriesSection />
      <FeaturedProducts />
      <SuccessStoriesSection />
      <AboutSection />
      <TestimonialsSection />
      <CTASection />
      <Footer />
    </main>
  );
}
